import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Announcement } from "../../lib/airtables/models";
import { setAnnouncements, setAnnouncementsUnread } from "../../redux/app/actions";
import airtable from "../../lib/airtables";
import { getNiceFormatDateString } from "../../helpers/time";
import { useAuth } from "../../auth/AuthProvider";
import {
  getHasUnreadAnnouncements,
  getLatestAnnouncementDate,
  getLastSeenAnnouncementAt,
  setLastSeenAnnouncementAtLocal
} from "../../lib/announcements/status";
import { teacherFieldIds } from "../../lib/airtables/tables/Teachers";
import { airtableFields } from "../../lib/airtables/schema";

export default function AnnouncementsPage() {
  const { announcements } = useSelector((state: any) => state.app)
  const dispatch = useDispatch();
  const { user } = useAuth();

  useEffect(() => {
    if (!announcements || !announcements.length) {
      airtable.announcements.getItemsForToday().then(
        (res: Announcement[]) => {
          dispatch(setAnnouncements(res));
          const lastSeen = getLastSeenAnnouncementAt(user);
          dispatch(setAnnouncementsUnread(getHasUnreadAnnouncements(res, lastSeen)));
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const userId = user?.id;
    if (!userId || !announcements?.length) return;

    const latestDate = getLatestAnnouncementDate(announcements);
    if (!latestDate) return;

    const lastSeen = getLastSeenAnnouncementAt(user);
    if (lastSeen && latestDate <= lastSeen) return;

    setLastSeenAnnouncementAtLocal(userId, latestDate);
    dispatch(setAnnouncementsUnread(false));
    const updatePromise = airtable.teachers?.update(userId, {
      [teacherFieldIds.lastSeenAnnouncementAt]: latestDate.toISOString()
    });
    if (updatePromise) {
      updatePromise.catch(() => {
        // Local storage already set as fallback.
      });
    }
  }, [announcements, dispatch, user]);

  return (
    <main className="dashboard-page page">
      <div className="max-w-7xl mx-auto my-12">
        <div className="announcements">
          {announcements.slice(0, 5).map((item: Announcement, i: number) => (
            <div
              key={i}
              className="flex flex-col py-2"
            >
              <div className="flex justify-between">
                <span className="text-base font-bold">{item[airtableFields.announcements.title]}</span>
                <span>{getNiceFormatDateString(new Date(item[airtableFields.announcements.liveDate]))}</span>
              </div>
              <p>{item[airtableFields.announcements.announcement]}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  )
}
